import { render, staticRenderFns } from "./quotas.vue?vue&type=template&id=23a00108&"
import script from "./quotas.vue?vue&type=script&lang=js&"
export * from "./quotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports